import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Select from 'react-select';

export default class ListSelectEditorField extends PureComponent {
  static propTypes = {
    input: PropTypes.object,
    multi: PropTypes.bool,
    typeOptions: PropTypes.object,
  };

  render() {
    const { input, multi, typeOptions } = this.props;
    const selectOptions = typeOptions && typeOptions.options ? typeOptions.options : null;
    const options = selectOptions && selectOptions.map(sel => ({ label: sel, value: sel }));

    return (
      <Select
        ref={input1 => {
          this.theInput = input1;
        }}
        multi={multi}
        simpleValue
        autoBlur
        joinValues
        clearable={false}
        searchable
        matchProp={'label'}
        matchPos={'any'}
        onBlurResetsInput={false}
        onCloseResetsInput={false}
        onBlurSelectsFocusedOption
        backspaceRemoves={false}
        cache={false}
        style={{ display: 'inline-block', height: 'auto' }}
        {...input}
        options={options}
        onBlur={() => {
          this.theInput.closeMenu();
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/types/ListSelect/ListSelectEditorField.js